import { StyledButton } from "@components/button";
import styled, { css } from "styled-components";

import Dialog from "../../components/dialog";

export const DialogStyledTemporalPropertyDialog = styled(Dialog)<{ showTimeLine: boolean; }>`
    ${props => props.showTimeLine && css`
        // move SmartFastEntryList add button
        ${StyledButton}:first-of-type {
            margin-left: 30px;
        }
    `};
`;